import React, { RefObject } from "react";
import { Guid } from "../../../api/baseApi";
import { DayOfWeek, EnableSlotRequest, TimeSlotModel } from "../../../api/channelsApi";
import { addLeadingZero } from "../../../services/common";
import SvgSelector from "../svgSelector/SvgSelector";
import "./Schedule.css"

interface ScheduleProps {
    timeSlots: TimeSlotModel[],
    onTimeSlotAdd: (timeSlot: TimeSlotModel) => void;
    onTimeSlotRemove: (id: Guid) => void;
    onTimeSlotRangeSelect?: (slots:any) => void,
}
 
interface ScheduleState {   
    startX: number,
    startY: number,
    endX: number,
    endY: number,
    isDrawing: boolean
}

 
class Schedule extends React.Component<ScheduleProps, ScheduleState> {
    dragAreaRef: RefObject<HTMLTableElement>;
    decoAreaRef: RefObject<HTMLDivElement>;

    constructor(props:ScheduleProps){
        super(props)

        this.state = {
            startX: 0,
            startY: 0,
            endX: 0,
            endY: 0,
            isDrawing: false,
        };
        this.dragAreaRef = React.createRef<HTMLTableElement>();
        this.decoAreaRef = React.createRef<HTMLDivElement>();
        
    }

    isUseRange = this.props.onTimeSlotRangeSelect ? true : false

    handleMouseDown = (e:React.MouseEvent<Element, MouseEvent>) => {
        if(this.dragAreaRef.current && this.decoAreaRef.current && this.isUseRange){
            let blockRect = this.dragAreaRef.current?.getBoundingClientRect();
            this.setState({
                startX: e.clientX - blockRect.left,
                startY: e.clientY - blockRect.top,
                isDrawing: true
            });
            this.decoAreaRef.current.style.left = e.clientX - blockRect.left + 'px';
            this.decoAreaRef.current.style.top = e.clientY - blockRect.top + 'px';
            this.decoAreaRef.current.style.width = '0px';
            this.decoAreaRef.current.style.height = '0px';
            this.decoAreaRef.current.style.opacity = "1"
        }
    };

    handleMouseMove = (e: React.MouseEvent<Element, MouseEvent>) => {
        if (!this.state.isDrawing) return;

        if(this.dragAreaRef.current && this.decoAreaRef.current && this.isUseRange){
            let blockRect = this.dragAreaRef.current?.getBoundingClientRect();

            let endX = e.clientX - blockRect.left
            let endY = e.clientY - blockRect.top
    
            const width = Math.abs(endX - this.state.startX);
            const height = Math.abs(endY - this.state.startY);
    
            this.decoAreaRef.current.style.width = width + 'px';
            this.decoAreaRef.current.style.height = height + 'px';
    
            if (endX < this.state.startX) {
                this.decoAreaRef.current.style.left = endX + 'px';
            }
            if (endY < this.state.startY) {
                this.decoAreaRef.current.style.top = endY + 'px';
            }
        }
    }

    handleMouseUp = (e: React.MouseEvent<Element, MouseEvent>) => {
        if(this.dragAreaRef.current && this.decoAreaRef.current && this.isUseRange){
            let blockRect = this.dragAreaRef.current.getBoundingClientRect();
            this.setState({
                isDrawing: false,
                endX: e.clientX - blockRect.left,
                endY: e.clientY - blockRect.top
            })

            this.decoAreaRef.current.removeAttribute("style")
            let selectedSlots = this.selectSlots(this.state.startX, this.state.startY, e.clientX, e.clientY);
            
            if(this.props.onTimeSlotRangeSelect){
                this.props.onTimeSlotRangeSelect({timeSlots: selectedSlots})
            }
        }
    };

    selectSlots = (startX:number, startY:number, endX:number, endY:number) => {
        let slots = this.dragAreaRef.current?.querySelectorAll(".slot-cell");
        if (!slots) {
            return;
        }

        let blockRect
        if(this.dragAreaRef.current){
            blockRect = this.dragAreaRef.current.getBoundingClientRect();
            startX += blockRect.left
            startY += blockRect.top
        }
        
        const newSelectedSlots: Array<EnableSlotRequest> = [];
        for (let i = 0; i < slots.length; i++) {
          const rect = (slots[i] as HTMLDivElement).getBoundingClientRect();
          if (
                rect.x + rect.width >= Math.min(startX, endX) &&
                rect.x <= Math.max(startX, endX) &&
                rect.y + rect.height >= Math.min(startY, endY) &&
                rect.y <= Math.max(startY, endY)
            ) {
                let currentSlot = (slots[i] as HTMLDivElement).dataset.slot
                if(currentSlot){
                    let splittedSlot = currentSlot.split("-")
                    newSelectedSlots.push({
                        dayOfWeek: +splittedSlot[0],
                        hour: +splittedSlot[1],
                        minute: +splittedSlot[2]
                    });
                }
            }
        }

        return newSelectedSlots
        
      };
    
    hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

    
    isSelected = (dayOfWeek : DayOfWeek, hour: number, minutes: number) => {
        const slot = this.props.timeSlots.find(
                timeSlot =>  timeSlot.dayOfWeek == dayOfWeek 
                && timeSlot.hour == hour
                && timeSlot.minute == minutes);

        return slot?.id;
    }

    renderScheduleRow = (hour : number, schedule: TimeSlotModel[]) => {
        const daysOfWeek = [1, 2, 3, 4, 5, 6, 0]

        return <tr key={hour}>
            <td>{addLeadingZero(hour, 2)}:00</td>
            {daysOfWeek.map(it => this.renderScheduleIndicator(hour, it))}   
        </tr>
    }

    renderScheduleIndicator = (hour: number, dayOfWeek: DayOfWeek) => {

        const firstHalfId = this.isSelected(dayOfWeek, hour, 0);
        const secondHafId = this.isSelected(dayOfWeek, hour, 30);  

        if(this.isUseRange){
            return <td key={`${dayOfWeek}-${hour}`}>
                    <div className="svg-block">
                        <div className="slot-cell" data-slot={`${dayOfWeek}-${hour}-0`}>
                            <SvgSelector title={ !!firstHalfId ? "ok" : "cross"} />
                        </div>
                        <div className="slot-cell" data-slot={`${dayOfWeek}-${hour}-30`}>
                            <SvgSelector title={ !!secondHafId ? "ok" : "cross"} />
                        </div>
                    </div>
                </td> 
        }

        return <td key={`${dayOfWeek}-${hour}`}>
                    <div className="svg-block">
                        <div className="slot-cell" 
                            data-slot={`${dayOfWeek}-${hour}-0`} 
                            onClick={
                            () => firstHalfId 
                                    ? this.props.onTimeSlotRemove(firstHalfId) 
                                    : this.props.onTimeSlotAdd({dayOfWeek: dayOfWeek, hour: hour, minute: 0, id: ""})
                            }
                            >
                            <SvgSelector title={ !!firstHalfId ? "ok" : "cross"} />
                        </div>
                        <div className="slot-cell" data-slot={`${dayOfWeek}-${hour}-30`} 
                            onClick={
                            () => secondHafId 
                                ? this.props.onTimeSlotRemove(secondHafId) 
                                : this.props.onTimeSlotAdd({dayOfWeek: dayOfWeek, hour: hour, minute: 30, id: ""})
                            }
                            >
                            <SvgSelector title={ !!secondHafId ? "ok" : "cross"} />
                        </div>
                    </div>
                </td>       
    }

    render() { 
        return (
            <div style={{"position":"relative"}}>
                <table className="table schedule-table" 
                    ref={this.dragAreaRef}
                    onMouseDown={this.handleMouseDown}
                    onMouseMove={this.handleMouseMove}
                    onMouseUp={this.handleMouseUp}
                    >
                    <thead>
                        <tr>
                            <td></td>
                            <td>Monday</td>
                            <td>Tuesday</td>
                            <td>Wednesday</td>
                            <td>Thursday</td>
                            <td>Friday</td>
                            <td>Saturday</td>
                            <td>Sunday</td>
                        </tr>
                    </thead>
                    <tbody>
                        {this.hours.map( it => this.renderScheduleRow(it, this.props.timeSlots))}                    
                    </tbody>
                </table>
               <div className="deco-area" ref={this.decoAreaRef}></div>
            </div>
        );
    }
}
 
export default Schedule;